const e = {
  color: {
    text: "#131b24ff",
    light: "#7e8e9eff",
    small: {
      text: "#405261ff"
    }
  }
};
export {
  e as heading
};
